import type { GarageItem } from '@/net/api';

/**
 * The order the title shelf is read in: tier first, then credits before
 * diamonds, then cheapest first inside each currency.
 *
 * The price compared is the one actually paid — `diamondPrice` on a premium
 * title, `price` on a credit one — never the credit valuation a premium row also
 * carries. Ties keep the server's order (`Array.prototype.sort` is stable), so
 * two titles at one price stay in catalogue order.
 */
export function sortTitlesForShop(items: readonly GarageItem[]): GarageItem[] {
  return [...items].sort(
    (a, b) =>
      a.tier - b.tier ||
      Number(a.diamondPrice !== null) - Number(b.diamondPrice !== null) ||
      (a.diamondPrice ?? a.price) - (b.diamondPrice ?? b.price),
  );
}
